import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ReviewActivityPayload } from "./@types";

const reviewValidation = async (payload: ReviewActivityPayload) => {
  const { data } = await apiInputService.post(
    "/activityItem/review-validation",
    payload,
  );

  return data;
};

export const useReviewActivityItemValidation = () => {
  return useMutation(reviewValidation);
};
